import * as Api from '@ViewModels';

export type PostBrandingBatch = {
	attachmentIds: string[];
	templateId?: string;
};

export function getBrandingBatchForAttachments(
	attachments: readonly Api.IFileAttachment[] | undefined
): PostBrandingBatch | null {
	if (!attachments?.length) {
		return null;
	}
	const seen = new Set<string>();
	const attachmentIds: string[] = [];
	for (const attachment of attachments) {
		if (!attachment?.id || !attachment.mimeType?.toLowerCase().startsWith('image/') || seen.has(attachment.id)) {
			continue;
		}
		seen.add(attachment.id);
		attachmentIds.push(attachment.id);
	}
	return attachmentIds.length > 0 ? { attachmentIds } : null;
}
